import type { DeviceSettings } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetDeviceSettingsList } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"

import { useDeviceSettingsSWRKey } from "./useDeviceSettingsSWRKey"

export function useDeviceSettingsList(): SWRResponse<Array<DeviceSettings>> {
  const deviceSettingsSWRKey = useDeviceSettingsSWRKey()
  const getDeviceSettingsList = useGetDeviceSettingsList()

  const getDeviceSettingsListData = useMemo(
    () => !getDeviceSettingsList ? null : (async () => {
      const response = await getDeviceSettingsList({ params: {} })
      return response
    }),
    [getDeviceSettingsList],
  )

  return useSWR<Array<DeviceSettings>>(
    deviceSettingsSWRKey,
    getDeviceSettingsListData,
  )
}
